

import { useTranslation } from 'react-i18next';

export default function ClashToast({
  styles,
  toast,
}) {
  const { t } = useTranslation('zodiacClash');
  return (
    <>
          {toast && (
        <div
          style={{
            ...styles.toast,
            ...(toast.tone === 'violet' ? styles.toastViolet : styles.toastGold),
          }}
          role="status"
          aria-live="polite"
        >
          <div style={styles.toastRow}>
            <div style={styles.toastIcon} aria-hidden="true">
              {toast.emoji || '✨'}
            </div>
            <div style={styles.toastTextWrap}>
              <div style={styles.toastLabel}>{t('cosmicInsight')}</div>
              <div style={styles.toastText}>{toast.text}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
